var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "twitter-verified-badge-1-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9582 14.0013C25.9582 12.333 24.9315 10.8863 23.4032 10.1046C23.9398 8.48297 23.6365 6.7213 22.4582 5.54297C21.2798 4.36464 19.5182 4.0613 17.8965 4.59797C17.1265 3.06964 15.6682 2.04297 13.9998 2.04297C12.3315 2.04297 10.8848 3.06964 10.1148 4.59797C8.4815 4.0613 6.71984 4.36464 5.5415 5.54297C4.36317 6.7213 4.0715 8.48297 4.60817 10.1046C3.07984 10.8863 2.0415 12.333 2.0415 14.0013C2.0415 15.6696 3.07984 17.1163 4.60817 17.898C4.0715 19.5196 4.36317 21.2813 5.5415 22.4596C6.71984 23.638 8.4815 23.9296 10.1032 23.4046C10.8848 24.933 12.3315 25.9596 13.9998 25.9596C15.6682 25.9596 17.1265 24.933 17.8965 23.4046C19.5182 23.9296 21.2798 23.638 22.4582 22.4596C23.6365 21.2813 23.9398 19.5196 23.4032 17.898C24.9315 17.1163 25.9582 15.6696 25.9582 14.0013ZM12.2965 18.9013L7.93317 14.538L9.57817 12.8813L12.2148 15.518L17.8148 9.4163L19.5298 11.003L12.2965 18.9013Z",
    fill: "#1D9BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.a27b8f653edec74582a431265caa85ce.svg";
export { ForwardRef as ReactComponent };